var INITIAL_DIALOG_STATE, INITIAL_STATE, LaserActions, appUtils, generateStore;

appUtils = require('lib/app_utils');

generateStore = require('stores/utils/generate_store');

LaserActions = require('actions/laser_actions');

INITIAL_DIALOG_STATE = Immutable.fromJS({
  isOpen: false,
  questionId: null,
  isCreating: false,
  selectedQuestions: Immutable.List()
});

INITIAL_STATE = Immutable.fromJS({
  meta: {
    isFetching: {},
    isSyncing: false,
    fetchingError: null,
    createQuestionInLaserDialog: INITIAL_DIALOG_STATE
  }
});

module.exports = generateStore({
  name: 'LaserStore',
  initialState: INITIAL_STATE,
  boundActions: [LaserActions],
  methods: {
    onSyncWithLaser: function() {
      return this.setState(this.state.setIn(['meta', 'isSyncing'], true));
    },
    onSyncingComplete: function() {
      return this.setState(this.state.setIn(['meta', 'isSyncing'], false));
    },
    onDownloadDataFromLaser: function(questionId) {
      return this.setState(this.state.setIn(['meta', 'isFetching', questionId], true));
    },
    onDownloadDataFromLaserComplete: function(questionId) {
      return this.setState(this.state.setIn(['meta', 'isFetching', questionId], false));
    },
    onOpenCreateQuestionInLaser: function(questionId) {
      return this.setState(this.state.withMutations(function(s) {
        s.setIn(['meta', 'createQuestionInLaserDialog', 'isOpen'], true);
        s.setIn(['meta', 'createQuestionInLaserDialog', 'questionId'], questionId);
        return s.setIn(['meta', 'createQuestionInLaserDialog', 'selectedQuestions'], Immutable.List([questionId]));
      }));
    },
    onCreateQuestionsInLaser: function() {
      return this.setState(this.state.setIn(['meta', 'createQuestionInLaserDialog', 'isCreating'], true));
    },
    onSetSelectedQuestions: function(selectedQuestions) {
      return this.setState(this.state.setIn(['meta', 'createQuestionInLaserDialog', 'selectedQuestions'], selectedQuestions));
    },
    getCreateQuestionInLaserMainId: function() {
      return this.state.getIn(['meta', 'createQuestionInLaserDialog', 'questionId'], null);
    },
    onCloseCreateQuestionInLaserDialog: function() {
      return this.setState(this.state.setIn(['meta', 'createQuestionInLaserDialog'], INITIAL_DIALOG_STATE));
    },
    isSyncing: function() {
      return this.state.getIn(['meta', 'isSyncing'], false);
    },
    isFetchingFromLaser: function(questionId) {
      return this.state.getIn(['meta', 'isFetching', questionId], false);
    },
    isCreatingQuestionInLaser: function() {
      return this.state.getIn(['meta', 'createQuestionInLaserDialog', 'isCreating']);
    },
    isCreatingQuestionDialogOpen: function() {
      return this.state.getIn(['meta', 'createQuestionInLaserDialog', 'isOpen'], false);
    },
    getSelectedQuestions: function() {
      return this.state.getIn(['meta', 'createQuestionInLaserDialog', 'selectedQuestions'], Immutable.List());
    }
  }
});
